module.exports = __webpack_public_path__ + "img/ne.a67f9534.svg";